import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (measurementId) {
    ReactGA.initialize(measurementId);
    console.log('✅ Google Analytics initialized');
  } else {
    console.warn('⚠️ GA Measurement ID not found in .env');
  }
};

// Track page views (automatic on route changes)
export const logPageView = (path) => {
  ReactGA.send({ 
    hitType: "pageview", 
    page: path
  });
  console.log('📊 Page view tracked:', path);
};

// Track button clicks
export const logButtonClick = (buttonName) => {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: buttonName,
  });
  console.log('🖱️ Button click tracked:', buttonName);
};

// Track product views
export const logProductView = (productName, productId) => {
  ReactGA.event({
    category: 'Product',
    action: 'View',
    label: productName,
    value: productId,
  });
  console.log('👁️ Product view tracked:', productName);
};

// Track form submissions
export const logFormSubmission = (formName) => {
  ReactGA.event({
    category: 'Form',
    action: 'Submit',
    label: formName,
  });
  console.log('📝 Form submission tracked:', formName);
};